import { Link } from 'components/Elements';
import { Head } from 'components/Head';
import PropTypes from 'prop-types';
import logo from 'assets/logo2.svg';
import BgImg from 'assets/bg.png';

export const Layout = ({ children, title }) => {
  return (
    <>
      <Head title={title} />
      <div
        className="min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${BgImg})` }}
        aria-label="Authentication Background"
      >
        <div className="mx-auto w-full max-w-4xl p-4 sm:p-8">
          <div className="flex flex-col sm:flex-row bg-white rounded-3xl shadow-lg overflow-hidden">
            <div className="flex flex-col justify-center items-start bg-[#0E3F66] text-white p-8 sm:w-1/2">
              <Link className="mb-6" to="/" aria-label="Go to homepage">
                <img className="h-16" src={logo} alt="Wire24 logo" />
              </Link>
              <h1 className="text-3xl font-bold tracking-tight mb-2">
                Gatekeeper
              </h1>
              <p className="text-sm opacity-90">
                This portal is restricted to authorized Wire24 administrators
                only. Please sign in to verify your identity and access wire24 services.
              </p>
              <p className="text-xs mt-4 text-gray-300">
                For internal use only. Activity is monitored.
              </p>
            </div>

            <div className="sm:w-1/2 p-6 sm:p-10">
              <div className="sm:mx-auto sm:w-full sm:max-w-md mb-6">
                <h2 className="text-start text-2xl font-bold text-gray-800">
                  {title}
                </h2>
              </div>
              {children}
              <div className="mt-6 text-xs text-center text-gray-400">
                Property of Wire24 or its affiliates. All rights reserved © 2025
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
